<template>
    <div component="VideoProjectItemVideos">
        <header @click="open" :class="{ isOpen }">
            <btn size="iconSmall" color="transparent" :icon="isOpen ? 'remove' : 'add'" />
            Recordings
        </header>
        <transition v-on:enter="enter" v-on:leave="leave">
            <footer v-if="isOpen">
                <div class="empty" v-if="!hasAnyVideos">You have not recorded any videos</div>
                <video-project-item-video :email-request="emailRequest" />
            </footer>
        </transition>
    </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import moment from 'moment';
import VideoProjectItemVideo from './VideoProjectItemVideo.vue';

export default {
    name: 'VideoProjectItemVideos',

    props: {
        emailRequest: {
            type: Object,
        },
    },

    data() {
        return {
            section: 'videos',
        };
    },

    computed: {
        ...mapGetters(['getActorVideoRequestSelectedSection']),

        isOpen() {
            return this.getActorVideoRequestSelectedSection === this.section;
        },

        /*hasPlayableVideos() {
            return this.emailRequest?.videos?.some((i) => i.converted_at) ?? false;
        },*/

        hasAnyVideos() {
            return this.emailRequest?.videos.length ?? false;
        },
    },

    methods: {
        ...mapMutations(['setActorVideoRequestSelectedSection']),

        enter(el, done) {
            Velocity(el, 'slideDown', { duration: 300, easing: 'easeInBack' }, { complete: done });
        },

        leave(el, done) {
            Velocity(el, 'slideUp', { duration: 300, easing: 'easeInBack' }, { complete: done });
        },

        getDateWithTime(date) {
            return `${moment(date).format('DD. MM. YYYY')}`;
        },

        open() {
            const section = this.isOpen ? null : this.section;
            this.setActorVideoRequestSelectedSection(section);
        },
    },

    components: { VideoProjectItemVideo },
};
</script>
<style lang="less" scoped>
@import '~@variables';

[component='VideoProjectItemVideos'] {
    .border-b;

    &:last-child {
        border-width: 0;
    }

    header {
        display: flex;
        align-items: center;
        font-weight: 900;
        cursor: pointer;
        padding: 5px 10px;
        border-bottom: 1px solid transparent;

        &.isOpen {
            background: fade(@black, 3%);
            border-color: @border;
        }

        button {
            margin-right: 10px;
        }
    }

    footer {
        padding: 0 15px 10px 45px;
    }
}
</style>
